console.log("ENV", process.env.REACT_APP_LAB_OS_STREAMLIT_URL);
const ENV = {
    API_URL: process.env.REACT_APP_API_URL,
    ADMIN_CONSOLE_URL: process.env.REACT_APP_ADMIN_CONSOLE_API,
    OCR_API_URL:process.env.REACT_APP_API_URL_FOR_OCR,
    OCR_UI_URL:process.env.REACT_APP_OCR_URL,
    APP_URL:process.env.REACT_APP_URL,
    ENV_MODE: process.env.REACT_APP_ENV,
    LAB_OS_URL: process.env.REACT_APP_LAB_OS_STREAMLIT_URL,
    ENABLE_REDUX_LOGS: (process.env.REACT_APP_ENABLE_REDUX_LOGS) === 'true',
    ENABLE_HTTP_LOGS: (process.env.REACT_APP_ENABLE_HTTP_LOGS) === 'true',
}

export default ENV;
